module.exports = __webpack_public_path__ + "static/media/Badge_PngMarquePrivilege_LRP.6ed4dccd.png";